import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth } from '../firebase'; // Assumes firebase.js is in src/
import { onAuthStateChanged } from 'firebase/auth';

export const UserContext = createContext({
  user: null,
  setUser: () => {},
  loadingAuth: true, 
});

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loadingAuth, setLoadingAuth] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      if (firebaseUser) {
        setUser({
          uid: firebaseUser.uid,
          email: firebaseUser.email,
          displayName: firebaseUser.displayName,
          photoURL: firebaseUser.photoURL,
          isGuest: false // Ensure isGuest is false for authenticated users
        });
      } else {
        // No Firebase user, set to null regardless of previous state
        setUser(null);
      }
      setLoadingAuth(false); // Set loading to false once auth state is determined
    });

    return () => unsubscribe(); // Cleanup subscription on unmount
  }, []);

  return (
    <UserContext.Provider value={{ user, setUser, loadingAuth }}>
      {children}
    </UserContext.Provider>
  );
};

// Custom hook to use UserContext
export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};
